
import {IProduct} from '@/types/models/IProduct';
import {defineComponent, PropType} from 'vue';

export default defineComponent({
  name: "product-item",
  props: {
    product: {
      type: Object as PropType<IProduct>,
      required: true,
    }
  },
})
